import { Middleware } from 'redux';
import { isRejectedWithValue } from '@reduxjs/toolkit';
import logger from '../../utils/logger';

/**
 * Middleware for handling training-specific errors, particularly Firebase permission issues
 */
export const trainingErrorMiddleware: Middleware = (store) => (next) => (action) => {
  // Check if this is a rejected action from any training-related async thunk
  if (isRejectedWithValue(action) && action.type.startsWith('training/')) {
    const errorPayload = action.payload;
    
    // Handle Firebase permission errors specifically
    if (
      errorPayload && 
      (
        (typeof errorPayload === 'object' && 'code' in errorPayload && errorPayload.code === 'PERMISSION_DENIED') ||
        (typeof errorPayload === 'string' && errorPayload.includes('permission_denied'))
      )
    ) {
      logger.warn('Firebase permission error in training action:', {
        type: action.type,
        error: errorPayload
      });
      
      // Here we could dispatch a notification action to show to the user
      // Or we could dispatch a special action to handle Firebase permission errors
      store.dispatch({
        type: 'training/permissionError',
        payload: {
          originalAction: action.type,
          timestamp: Date.now()
        }
      });
      
      // Don't break the chain, but we could return a modified action
      // that won't trigger error UI if we don't want to show these errors
    }
    
    // Log all other training errors
    if (
      errorPayload && 
      !(typeof errorPayload === 'object' && 'code' in errorPayload && errorPayload.code === 'PERMISSION_DENIED')
    ) {
      logger.error('Training action error:', {
        type: action.type,
        error: errorPayload
      });
    }
  }
  
  return next(action);
};

export default trainingErrorMiddleware;